export const data = {
  clients: {
    data: [
      { Fecha: "2024-01-01", Cantidad: 70 },
      { Fecha: "2024-02-02", Cantidad: 50 },
      { Fecha: "2024-03-03", Cantidad: 45 },
      { Fecha: "2024-04-04", Cantidad: 60 },
      { Fecha: "2024-05-05", Cantidad: 40 },
      { Fecha: "2024-06-06", Cantidad: 10 },
      { Fecha: "2024-06-07", Cantidad: 12 },
      { Fecha: "2024-06-08", Cantidad: 8 },
      { Fecha: "2024-06-09", Cantidad: 6 },
      { Fecha: "2024-06-10", Cantidad: 7 },
      { Fecha: "2024-06-11", Cantidad: 9 },
      { Fecha: "2024-06-12", Cantidad: 11 },
      { Fecha: "2024-06-13", Cantidad: 10 },
    ],
  },

  descargas: {
    data: [
      { Fecha: "2024-01-01", Cantidad: 62 },
      { Fecha: "2024-02-02", Cantidad: 17 },
      { Fecha: "2024-03-03", Cantidad: 34 },
      { Fecha: "2024-06-06", Cantidad: 30 },
      { Fecha: "2024-06-07", Cantidad: 7 },
      { Fecha: "2024-06-08", Cantidad: 16 },
    ],
  },
  productData: {
    data: [
      { Bebida: "Coca-cola 500cc", Cantidad: 120 },
      { Bebida: "Sprite 1.5 litros", Cantidad: 80 },
      { Bebida: "Monster Energy", Cantidad: 100 },
      { Bebida: "Power Ade Manzana", Cantidad: 90 },
      { Bebida: "Cepita del Valle Multifruta", Cantidad: 70 },
      { Bebida: "Aquarius Pera", Cantidad: 50 },
      { Bebida: "Smartwater", Cantidad: 60 },
      { Bebida: "Fanta 2.5 litros", Cantidad: 110 },
    ],
  },
  combos: [
    { Combo: "Simple", Cantidad: 44 },
    { Combo: "Duo", Cantidad: 66 },
  ],
  formato: [
    { Formato: "Cuadrado", Cantidad: 31 },
    { Formato: "Rectangulo", Cantidad: 57 },
  ],
};
